import { jsxs as k, jsx as _ } from "react/jsx-runtime";
import { useRef as A, useState as z, useMemo as W, useCallback as w, useEffect as D } from "react";
import { V as v } from "./index-D6IbTb4M.js";
import { c as H } from "./clsx-OuTLNxxd.js";
import { B as V } from "./Button-DhycXY8d.js";
import './TableScrollContainer.css';const x = 600, I = ({ cellWidth: C, maxRows: p }) => {
  const u = A(null), [a, c] = z(0), [T, B] = z(!1), [l, y] = z({
    pinCount: 0,
    rowCount: 0,
    headings: null
  }), [f, g] = z({
    top: !1,
    bottom: !1,
    left: !1,
    right: !1
  }), e = W(
    () => f.left || f.right,
    [f.left, f.right]
  ), i = w(() => {
    if (!u.current) return null;
    const t = u.current.querySelector("table"), o = u.current.getElementsByTagName("thead")[0], n = u.current.getElementsByTagName("tbody")[0], d = u.current.getElementsByTagName("tfoot")[0];
    if (!t || !o) return null;
    const s = o.getElementsByTagName("th");
    return s.length ? { container: u.current, table: t, headings: s, tbody: n, tfoot: d } : null;
  }, []), h = w(() => {
    var m;
    const t = i();
    if (!t) return;
    const { headings: o, tbody: n } = t, d = ((m = n == null ? void 0 : n.getElementsByTagName("tr")) == null ? void 0 : m.length) || 0, s = T ? 0 : [...o].filter((b) => b.dataset.pinned === "true").length;
    y({
      pinCount: s,
      rowCount: d,
      headings: o
    });
  }, [i, T]), E = w(() => {
    const t = i();
    if (!t) return { left: !1, right: !1 };
    const { container: o, table: n } = t, d = o.clientWidth, s = n.clientWidth, m = a >= 0, b = a <= -(s - d);
    return {
      left: !m,
      right: !b && s > d
    };
  }, [a, i]), N = w(() => {
    if (!l.headings)
      return { top: !1, bottom: !1 };
    const t = i();
    if (!t || !t.tbody || !t.tfoot)
      return { top: !1, bottom: !1 };
    const { tbody: o, tfoot: n } = t, d = l.headings[0].getBoundingClientRect().bottom, s = n.getBoundingClientRect().top, m = o.getBoundingClientRect().top, b = o.getBoundingClientRect().bottom;
    return {
      top: m < d,
      bottom: b > s
    };
  }, [i, l.headings]), S = w(
    (t = !1) => {
      const o = E();
      if (t) {
        const n = N();
        g({
          ...o,
          ...n
        });
      } else
        g((n) => ({
          ...n,
          ...o
        }));
    },
    [E, N]
  ), M = w(
    (t) => {
      const o = i();
      if (!o) return;
      const { container: n, table: d } = o, s = n.clientWidth, m = d.clientWidth, b = Math.max(0, m - s), F = t === "left" ? Math.min(0, a + C) : Math.max(-b, a - C);
      c(F), S();
    },
    [C, S, a, i]
  );
  return D(() => {
    B(window.innerWidth <= x), h();
    const t = !!p && !!l.rowCount && p < l.rowCount;
    S(t);
    const o = () => {
      B(window.innerWidth <= x), h(), S(!!p);
    };
    return window.addEventListener("resize", o), () => {
      window.removeEventListener("resize", o);
    };
  }, [p, S, h, l.rowCount]), {
    scrollRef: u,
    currentTransform: a,
    scrollDirection: f,
    shouldShowScrollButtons: e,
    pinCount: l.pinCount,
    onScrollClick: M,
    checkScroll: S,
    rowCount: l.rowCount
  };
}, L = "_wrapper_fih1d_32", j = "_captionWrapper_fih1d_41", O = "_caption_fih1d_41", $ = "_buttonWrapper_fih1d_58", q = "_button_fih1d_58", K = "_innerWrapper_fih1d_72", P = "_hasMaxHeight_fih1d_78", X = "_hasScrollShadowEnd_fih1d_82", G = "_hasScrollShadowStart_fih1d_91", J = "_hasScrollShadowTop_fih1d_100", Q = "_hasScrollShadowBottom_fih1d_109", R = "_hasVerticalScroll_fih1d_126", U = "_hasHorizontalScroll_fih1d_130", Y = "_scrollFullWidth_fih1d_134", r = {
  wrapper: L,
  captionWrapper: j,
  caption: O,
  buttonWrapper: $,
  button: q,
  innerWrapper: K,
  hasMaxHeight: P,
  hasScrollShadowEnd: X,
  hasScrollShadowStart: G,
  hasScrollShadowTop: J,
  hasScrollShadowBottom: Q,
  hasVerticalScroll: R,
  hasHorizontalScroll: U,
  scrollFullWidth: Y
}, rt = ({
  caption: C,
  cellWidth: p = 60,
  children: u,
  className: a,
  maxRows: c,
  ...T
}) => {
  const {
    checkScroll: B,
    currentTransform: l,
    onScrollClick: y,
    pinCount: f,
    rowCount: g,
    scrollDirection: e,
    scrollRef: i,
    shouldShowScrollButtons: h
  } = I({
    maxRows: c,
    cellWidth: p
  }), E = W(
    () => H(
      r.wrapper,
      {
        [r.hasScrollShadowTop]: e.top,
        [r.hasScrollShadowBottom]: e.bottom,
        [r.scrollFullWidth]: !e.left || !h,
        [r.hasVerticalScroll]: e.top || e.bottom,
        [r.hasHorizontalScroll]: e.left || e.right
      },
      a
    ),
    [a, e, h]
  ), N = W(
    () => H(r.innerWrapper, {
      [r.hasMaxHeight]: c,
      [r.hasScrollShadowEnd]: h && e.right,
      [r.hasScrollShadowStart]: h && e.left
    }),
    [c, h, e.right, e.left]
  ), S = W(
    () => ({
      "--maxRows": g && c && g < c ? g : c,
      "--cellWidth": `${p}px`,
      "--pinCount": f
    }),
    [p, c, f, g]
  ), M = W(
    () => ({
      "--table-horizontal-offset": `translateX(${l}px)`
    }),
    [l]
  );
  return /* @__PURE__ */ k("div", { className: E, style: S, ...T, children: [
    /* @__PURE__ */ k("div", { className: r.captionWrapper, children: [
      /* @__PURE__ */ _("h2", { className: r.caption, children: C }),
      h && /* @__PURE__ */ k("div", { className: r.buttonWrapper, "data-testid": "scroll-controls", children: [
        /* @__PURE__ */ _(
          V,
          {
            "aria-label": "scroll table left",
            className: r.button,
            disabled: !e.left,
            onClick: () => y("left"),
            variant: "ghost",
            children: /* @__PURE__ */ _(v, { size: "xsm" })
          }
        ),
        /* @__PURE__ */ _(
          V,
          {
            "aria-label": "scroll table right",
            className: r.button,
            disabled: !e.right,
            onClick: () => y("right"),
            variant: "ghost",
            children: /* @__PURE__ */ _(v, { size: "xsm" })
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ _(
      "div",
      {
        className: N,
        onScroll: () => B(!!c),
        ref: i,
        style: M,
        children: u
      }
    )
  ] });
};
export {
  rt as T
};
